import { useState, useEffect } from "react";
import Button from "../../ui/Button";
import { useUpdateLead, useCreateProject, useUser, useUpdateProject, useAddProjectStatus } from "../../Use-auth";
import Input from "../../ui/Input";

const InfoRow = ({ label, value }) => (
    <tr className="text-[10px] sm:text-[12px]">
        <td className="px-4 py-3 font-medium text-gray-600 w-1/3 ">
            {label}
        </td>

        <td className="px-4 py-3 text-gray-800 text-right zx:text-left">
            {value || "-"}
        </td>
    </tr>
);

const leadSources = [
    "Email Marketing",
    "Direct Website",
    "Referral",
    "Upwork",
    "LinkedIn",
    "Google Search (Organic SEO)",
    "Google Ads",
    "Facebook",
    "Instagram",
    "YouTube",
    "Newsletter Signups",
    "Online Chat / Chatbot",
    "WhatsApp Inquiry",
    "Cold Calls",
    "Cold Emails",
    "Previous Clients",
    "Pinterest",
    "Threads",
    "X",
    "Reddit",
];

export default function ProjectInformation({ editingLead, setEditingLead, Trash2, Pencil, Eye, Button, X }) {
    const updateLead = useUpdateLead();
    const [showModal, setShowModal] = useState(false);
    const [editingProjectIndex, setEditingProjectIndex] = useState(null);
    const [previewLeads, setPreviewLeads] = useState(null);
    const [showProjectForm, setShowProjectForm] = useState(false);
    const [leadsloading, setLeadsLoading] = useState(false);
    const [formData, setFormData] = useState({
        title: "",
        leadSource: [],
        company: "",
        website: "",
        description: "",
        budget: "",
        rate: "Fixed",
        hourlyRate: "",
        chargedHours: "",
        upfrontAmount: "",
        pendingAmount: "",
        totalCharged: "",
        spentConnects: "",
        leadId: "",
        jobLink: "",
    });

    const addStatusMutation = useAddProjectStatus();
    const createProject = useCreateProject();
    const updateProject = useUpdateProject();
    const { data: currentUser } = useUser();
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [messageType, setMessageType] = useState("");
    const [projectData, setProjectData] = useState({
        projectName: "",
        projectTitle: "",
        storeLink: "",
        figmaLink: "",
        description: ""
    });

    const handleChangeProjects = (e) => {
        const { name, value } = e.target;

        setProjectData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "leadSource") {
            setFormData((prev) => {
                const alreadySelected = prev.leadSource.includes(value);

                return {
                    ...prev,
                    leadSource: alreadySelected
                        ? prev.leadSource.filter((v) => v !== value)
                        : [...prev.leadSource, value],
                };
            });
            return;
        }
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = () => {
        if (!formData.title) {
            alert("Project title is required");
            return;
        }
        setLeadsLoading(true);
        const projectData = {
            title: formData.title,
            leadSource: formData.leadSource.join(", "),
            company: formData.company,
            website: formData.website,
            description: formData.description,
            budget: formData.budget || "0.00",
            rate: formData.rate,
            hourlyRate: Number(formData.hourlyRate || 0),
            chargedHours: Number(formData.chargedHours || 0),
            upfrontAmount: Number(formData.upfrontAmount || 0),
            pendingAmount: Number(formData.pendingAmount || 0),
            totalCharged: Number(formData.totalCharged || 0),
            spentConnects: Number(formData.spentConnects || 0),
            leadId: formData.leadId || "",
            jobLink: formData.jobLink || "",
        };

        let updatedProjects = [...projects];

        if (editingProjectIndex !== null) {
            updatedProjects[editingProjectIndex] = projectData;
        } else {
            updatedProjects.push(projectData);
        }

        updateLead.mutate(
            {
                leadId: editingLead?.id || editingLead?._id,
                projects: updatedProjects,
            },
            {
                onSuccess: (res) => {
                    setProjects(updatedProjects);

                    setEditingLead(prev => ({
                        ...prev,
                        projects: updatedProjects
                    }));
                    setLeadsLoading(false);
                    setShowModal(false);
                    setEditingProjectIndex(null);

                    setFormData({
                        title: "",
                        leadSource: [],
                        company: "",
                        website: "",
                        description: "",
                        budget: "",
                        rate: "Fixed",
                        hourlyRate: "",
                        chargedHours: "",
                        upfrontAmount: "",
                        pendingAmount: "",
                        totalCharged: "",
                        spentConnects: "",
                        leadId: "",
                        jobLink: "",
                    });
                },
                onError: () => {
                    setLeadsLoading(false);
                }
            }
        );
    };

    const [projects, setProjects] = useState(editingLead.projects || []);

    useEffect(() => {
        if (editingLead?.projects) {
            setProjects(editingLead.projects);
        }
    }, [editingLead]);

    const truncate = (text = "", num = 20) => {
        return text.length > num ? text.slice(0, num) + "..." : text;
    };

    const hasHourly = projects.some(p => p.rate !== "Fixed");

    const handleDeleteProject = async (index) => {
        const confirmDelete = window.confirm("Delete this project?");
        if (!confirmDelete) return;

        const updatedProjects = [...projects];
        updatedProjects.splice(index, 1);

        setProjects(updatedProjects);

        await updateLead.mutateAsync({
            leadId: editingLead?.id || editingLead?._id,
            projects: updatedProjects,
        });
    };

    const [showFullDesc, setShowFullDesc] = useState(false);

    const truncateText = (text, limit = 200) => {
        if (!text) return "-";
        if (text.length <= limit) return text;
        return text.slice(0, limit) + "...";
    };

    useEffect(() => {
        if (formData.rate === "Hourly") {
            if (formData.hourlyRate === "" || formData.chargedHours === "") return;
            const budget = Number(formData.budget);
            const hourly = Number(formData.hourlyRate);
            const hours = Number(formData.chargedHours);
            const charged = hourly * hours;
            const pending = Math.max(0, budget - charged);

            setFormData((prev) => ({
                ...prev,
                totalCharged: charged.toFixed(2),
                pendingAmount: pending.toFixed(2),
            }));
        }
    }, [
        formData.rate,
        formData.budget,
        formData.hourlyRate,
        formData.chargedHours,
    ]);

    useEffect(() => {
        if (formData.rate === "Fixed") {
            const budget = Number(formData.budget || 0);
            const upfront = Number(formData.upfrontAmount || 0);

            const pending = Math.max(0, budget - upfront);

            setFormData((prev) => ({
                ...prev,
                totalCharged: upfront.toFixed(2),
                pendingAmount: pending.toFixed(2),
            }));
        }
    }, [
        formData.rate,
        formData.budget,
        formData.upfrontAmount,
    ]);

    const handleSaveProject = async () => {
        setLoading(true);
        setMessage("");

        const DEFAULT_STATUSES = ["Pending", "Progress", "Testing", "Complete"];

        const currentUserName =
            currentUser?.fullName ||
            currentUser?.firstName ||
            currentUser?.username ||
            "Admin";

        const createdByTask = {
            userId: currentUser?.userId || currentUser?._id || "admin",
            fullName: currentUserName,
            email: currentUser?.email || "info@hubsyntax.com",
        };

        try {
            const projectRes = await createProject.mutateAsync({
                projectName: projectData.projectName,
                createdBy: createdByTask,
                status: "Not started",
            });

            const projectId = projectRes?.data?.id;

            if (!projectId) {
                console.error("Project ID missing:", projectRes);
                setMessage("Project ID not returned");
                return;
            }

            try {
                for (const status of DEFAULT_STATUSES) {
                    await addStatusMutation.mutateAsync({
                        projectId,
                        status,
                        createdBy: currentUserName,
                    });
                }
            } catch (err) {
                console.error(" Status creation failed:", err);
            }

            await updateProject.mutateAsync({
                id: projectId,
                taskTitle: projectData.projectTitle,
                status: "Progress",
                createdByTask: createdByTask,
                comments: [
                    {
                        text: `${currentUserName} created this task`,
                        createdBy: currentUserName,
                        createdAt: new Date(),
                    },
                ],
                description: [
                    {
                        storeLink: projectData.storeLink,
                        figmaLink: projectData.figmaLink,
                        subdescription: projectData.description,
                        taskdescription: [],
                    },
                ],
            });

            setMessage("Project created successfully");
            setMessageType("success");
            setProjectData({
                projectName: "",
                projectTitle: "",
                storeLink: "",
                figmaLink: "",
                description: ""
            });

        } catch (error) {
            console.error(" Project save error:", error);
            setMessage("Error creating project");
            setMessageType("error");
        } finally {
            setLoading(false);
        }
    };

    const handleNumberChange = (e) => {
        const { name, value } = e.target;

        if (/^\d*\.?\d*$/.test(value)) {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    };

    return (
        <div className="w-full bg-white rounded-xl  border border-gray-200 p-1 sm:p-6 mt-6">

            <div className="mb-3 sm:mb-5 pb-1 sm:pb-3">
                <h2 className="text-[14px] sm:text-[16px] font-semibold text-gray-800">
                    Project Information
                </h2>
            </div>
            <div className="overflow-x-auto shadow-md">
                <table className="w-full border border-gray-200 rounded-lg overflow-hidden border-collapse">
                    <thead className="bg-gray-100 text-sm text-gray-700">
                        <tr>
                            <th className="px-1 py-2 xl:px-3 xl:py-3 text-left text-[12px] xl:text-sm ">Project Name</th>
                            <th className="px-1 py-2 xl:px-3 xl:py-3 text-left text-[12px] xl:text-sm">Total Budget</th>
                            <th className="px-1 py-2 xl:px-3 xl:py-3 text-left text-[12px] xl:text-sm hidden zs:table-cell">Contract Type</th>
                            {hasHourly && (
                                <th className="px-1 py-2 xl:px-3 xl:py-3 text-left text-[12px] xl:text-sm hidden custom:table-cell">Hourly Rate</th>
                            )}
                            {hasHourly && (
                                <th className="px-1 py-2 xl:px-3 xl:py-3 text-left text-[12px] xl:text-sm hidden custom:table-cell">Charged Hrs</th>
                            )}
                            <th className="px-1 py-2 xl:px-3 xl:py-3 text-left text-[12px] xl:text-sm hidden rs:table-cell">Upfront Amount</th>
                            <th className="px-1 py-2 xl:px-3 xl:py-3 text-left text-[12px] xl:text-sm hidden rs:table-cell">Pending Amount</th>
                            <th className="px-1 py-2 xl:px-3 xl:py-3 text-left text-[12px] xl:text-sm hidden rs:table-cell">Total Charged</th>
                            <th className="px-1 py-2 xl:px-3 xl:py-3 text-left text-[12px] xl:text-sm">Actions</th>
                        </tr>
                    </thead>

                    <tbody className="divide-y divide-gray-200 text-sm">
                        {projects.map((project, index) => (
                            <tr key={index} className="hover:bg-gray-50">

                                <td className="px-1 py-2 xl:px-3 xl:py-3 text-[12px] xl:text-sm font-medium text-gray-800">
                                    {truncate(project.title)}
                                </td>

                                <td className="px-1 py-2 xl:px-3 xl:py-3 text-[12px] xl:text-sm">
                                    ${project.budget || "0.00"}
                                </td>

                                <td className="px-1 py-2 xl:px-3 xl:py-3 text-[12px] xl:text-sm hidden zs:table-cell">
                                    {project.rate || "-"}
                                </td>

                                {hasHourly && (
                                    <td className="px-1 py-2 xl:px-3 xl:py-3 text-[12px] xl:text-sm hidden custom:table-cell">
                                        ${project.hourlyRate || "0.00"}
                                    </td>
                                )}

                                {hasHourly && (
                                    <td className="px-1 py-2 xl:px-3 xl:py-3 text-[12px] xl:text-sm hidden custom:table-cell">
                                        {project.chargedHours || "0"}
                                    </td>
                                )}

                                <td className="px-1 py-2 xl:px-3 xl:py-3 text-[12px] xl:text-sm hidden rs:table-cell">
                                    ${project.upfrontAmount || "0.00"}
                                </td>

                                <td className="px-1 py-2 xl:px-3 xl:py-3 text-[12px] xl:text-sm hidden rs:table-cell text-red-600 font-medium">
                                    ${project.pendingAmount || "0.00"}
                                </td>

                                <td className="px-1 py-2 xl:px-3 xl:py-3 text-[12px] xl:text-sm hidden rs:table-cell text-green-600 font-semibold">
                                    ${project.totalCharged || "0.00"}
                                </td>

                                <td className="px-1 py-2 xl:px-3 xl:py-3 text-[12px] xl:text-sm flex gap-1">
                                    <div className="p-1 rounded cursor-pointer hover:bg-orange-100"
                                        onClick={() => {
                                            setPreviewLeads(project)
                                        }}>
                                        <Eye size={16} color="orange" />
                                    </div>

                                    <div
                                        className="p-1 rounded cursor-pointer hover:bg-blue-100"
                                        onClick={() => {

                                            setFormData({
                                                title: project.title || "",
                                                leadSource: project.leadSource
                                                    ? project.leadSource.split(",").map((s) => s.trim())
                                                    : [],
                                                company: project.company || "",
                                                website: project.website || "",
                                                description: project.description || "",
                                                budget: project.budget || "",
                                                rate: project.rate || "Fixed",
                                                hourlyRate: project.hourlyRate || "",
                                                chargedHours: project.chargedHours || "",
                                                upfrontAmount: project.upfrontAmount || "",
                                                pendingAmount: project.pendingAmount || "",
                                                totalCharged: project.totalCharged || "",
                                                spentConnects: project.spentConnects || "",
                                                leadId: project.leadId || "",
                                                jobLink: project.jobLink || "",
                                            });

                                            setEditingProjectIndex(index);
                                            setShowModal(true);
                                        }}
                                    >
                                        <Pencil size={16} color="blue" />
                                    </div>

                                    <div
                                        className="p-1 rounded cursor-pointer hover:bg-red-100"
                                        onClick={() => handleDeleteProject(index)}
                                    >
                                        <Trash2 size={16} color="red" />
                                    </div>
                                </td>
                            </tr>
                        ))}
                        <tr className="bg-gray-200 font-bold text-[14px] xl:text-[16px] h-[55px]">
                            <td className="px-2 py-2 sm:px-4 sm:py-4 xl:px-5 xl:py-4">
                                Total
                            </td>

                            <td className="px-2 py-2 sm:px-4 sm:py-4 xl:px-5 xl:py-4">
                                $
                                {projects
                                    .reduce((sum, p) => sum + Number(p.budget || 0), 0)
                                    .toFixed(2)}
                            </td>

                            <td className="px-2 py-2 sm:px-4 sm:py-4 hidden zs:table-cell"></td>

                            {hasHourly && (
                                <td className="px-2 py-2 sm:px-4 sm:py-4 hidden custom:table-cell"></td>
                            )}

                            {hasHourly && (
                                <td className="px-2 py-2 sm:px-4 sm:py-4 hidden custom:table-cell"></td>
                            )}

                            <td className="px-2 py-2 sm:px-4 sm:py-4 hidden rs:table-cell"></td>

                            <td className="px-2 py-2 sm:px-4 sm:py-4 hidden rs:table-cell text-red-600">
                                $
                                {projects
                                    .reduce((sum, p) => sum + Number(p.pendingAmount || 0), 0)
                                    .toFixed(2)}
                            </td>

                            <td className="px-4 py-4 hidden rs:table-cell text-green-700">
                                $
                                {projects
                                    .reduce((sum, p) => sum + Number(p.totalCharged || 0), 0)
                                    .toFixed(2)}
                            </td>

                            <td className="px-4 py-4"></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="flex justify-end">
                <Button
                    onClick={() => {
                        setShowModal(true);
                        setFormData({
                            title: "",
                            leadSource: [],
                            company: "",
                            website: "",
                            description: "",
                            budget: "",
                            rate: "Fixed",
                            hourlyRate: "",
                            chargedHours: "",
                            upfrontAmount: "",
                            pendingAmount: "",
                            totalCharged: "",
                        });
                    }}
                    variant="default"
                    className="mt-6"
                >
                    Add Records
                </Button>
            </div>

            {
                showModal && (
                    <div className="fixed inset-0 z-50 flex items-center  justify-center bg-black/40 px-2 sm:px-4" onClick={() => setShowModal(null)}>
                        <div
                            className="bg-white relative rounded-lg w-full max-w-[1400px] h-[90vh] shadow-lg  overflow-hidden overflow-y-auto animate-scaleIn"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div className="sticky top-0 z-10 flex justify-between items-center bg-gray-900 px-2 py-2 xl:px-3 xl:py-3">
                                <h2 className="text-[14px] sm:text-[18px] font-semibold text-white">
                                    Add Project Record
                                </h2>
                                <button
                                    className="text-white hover:text-red-400"
                                    onClick={() => setShowModal(null)}
                                >
                                    <X size={20} />
                                </button>
                            </div>

                            <div className="grid grid-cols-2 gap-4 p-2 sm:p-6">
                                {/* Project Title */}
                                <div>
                                    <label className="block text-[10px] sm:text-[13px] font-medium mb-1">
                                        Project Title *
                                    </label>
                                    <input
                                        name="title"
                                        value={formData.title}
                                        onChange={handleChange}
                                        className="w-full border p-2 rounded text-[10px] sm:text-[12px]"
                                    />
                                </div>

                                {/* Lead Source */}
                                <div>
                                    <label className="block text-[10px] sm:text-[13px] font-medium mb-1">
                                        Lead Source
                                    </label>

                                    <div className="border rounded p-2 max-h-[120px] overflow-y-auto">
                                        {leadSources.map((source) => (
                                            <label key={source} className="flex items-center gap-2 text-[10px] sm:text-[12px]">
                                                <input
                                                    type="checkbox"
                                                    name="leadSource"
                                                    value={source}
                                                    checked={(formData.leadSource || []).includes(source)}
                                                    onChange={handleChange}
                                                />
                                                {source}
                                            </label>
                                        ))}
                                    </div>
                                </div>

                                {/* Company */}
                                <div>
                                    <label className="block text-[10px] sm:text-[13px] font-medium mb-1">
                                        Company
                                    </label>
                                    <input
                                        name="company"
                                        value={formData.company}
                                        onChange={handleChange}
                                        className="w-full border p-2 rounded text-[10px] sm:text-[12px]"
                                    />
                                </div>

                                {/* Website */}
                                <div>
                                    <label className="block text-[10px] sm:text-[13px] font-medium mb-1">
                                        Website
                                    </label>
                                    <input
                                        name="website"
                                        value={formData.website}
                                        onChange={handleChange}
                                        className="w-full border p-2 rounded text-[10px] sm:text-[12px]"
                                    />
                                </div>

                                {/* Spent Connects */}
                                <div>
                                    <label className="block text-[10px] sm:text-[13px] font-medium mb-1">
                                        Spent Connects
                                    </label>
                                    <input
                                        name="spentConnects"
                                        value={formData.spentConnects}
                                        onChange={handleNumberChange}
                                        className="w-full border p-2 rounded text-[10px] sm:text-[12px]"
                                    />
                                </div>

                                {/* Lead Id */}
                                <div>
                                    <label className="block text-[10px] sm:text-[13px] font-medium mb-1">
                                        Lead Id
                                    </label>
                                    <input
                                        name="leadId"
                                        value={formData.leadId}
                                        onChange={handleChange}
                                        className="w-full border p-2 rounded text-[10px] sm:text-[12px]"
                                    />
                                </div>

                                {/* Job Link */}
                                <div className="col-span-2">
                                    <label className="block text-[10px] sm:text-[13px] font-medium mb-1">
                                        Job Proposal Link
                                    </label>
                                    <input
                                        name="jobLink"
                                        value={formData.jobLink}
                                        onChange={handleChange}
                                        className="w-full border p-2 rounded text-[10px] sm:text-[12px]"
                                    />
                                </div>

                                {/* Budget */}
                                <div>
                                    <label className="block text-[10px] sm:text-[13px] font-medium mb-1">
                                        Budget ($)
                                    </label>
                                    <input
                                        name="budget"
                                        value={formData.budget}
                                        onChange={handleNumberChange}
                                        className="w-full border p-2 rounded text-[10px] sm:text-[12px]"
                                    />
                                </div>

                                {/* Contract Type */}
                                <div>
                                    <label className="block text-[10px] sm:text-[13px] font-medium mb-1">
                                        Contract Type
                                    </label>
                                    <select
                                        name="rate"
                                        value={formData.rate}
                                        onChange={handleChange}
                                        className="w-full border p-2 rounded text-[10px] sm:text-[12px]"
                                    >
                                        <option value="Fixed">Fixed</option>
                                        <option value="Hourly">Hourly</option>
                                    </select>
                                </div>

                                {/* Hourly Rate */}
                                {formData.rate === "Hourly" && (
                                    <>
                                        <div>
                                            <label className="block text-[10px] sm:text-[13px] font-medium mb-1">
                                                Hourly Rate ($)
                                            </label>
                                            <input
                                                name="hourlyRate"
                                                value={formData.hourlyRate}
                                                onChange={handleNumberChange}
                                                className="w-full border p-2 rounded text-[10px] sm:text-[12px]"
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-[10px] sm:text-[13px] font-medium mb-1">
                                                Charged Hours
                                            </label>
                                            <input
                                                name="chargedHours"
                                                value={formData.chargedHours}
                                                onChange={handleNumberChange}
                                                className="w-full border p-2 rounded text-[10px] sm:text-[12px]"
                                            />
                                        </div>
                                    </>
                                )}

                                {/* Upfront Amount */}
                                {formData.rate === "Fixed" && (<div>
                                    <label className="block text-[10px] sm:text-[13px] font-medium mb-1">
                                        Upfront Amount ($)
                                    </label>
                                    <input
                                        name="upfrontAmount"
                                        value={formData.upfrontAmount}
                                        onChange={handleNumberChange}
                                        className="w-full border p-2 rounded text-[10px] sm:text-[12px]"
                                    />
                                </div>)}

                                {/* Pending Amount */}
                                <div>
                                    <label className="block text-[10px] sm:text-[13px] font-medium mb-1">
                                        Pending Amount ($)
                                    </label>
                                    <input
                                        name="pendingAmount"
                                        value={formData.pendingAmount}
                                        onChange={handleNumberChange}
                                        className="w-full border p-2 rounded text-[10px] sm:text-[12px]"
                                    />
                                </div>

                                {/* Total Charged */}

                                <div>
                                    <label className="block text-[10px] sm:text-[13px] font-medium mb-1">
                                        Total Charged ($)
                                    </label>
                                    <input
                                        name="totalCharged"
                                        value={formData.totalCharged}
                                        onChange={handleNumberChange}
                                        className="w-full border p-2 rounded text-[10px] sm:text-[12px]"
                                    />
                                </div>

                                {/* Description */}
                                <div className="col-span-2">
                                    <label className="block text-[10px] sm:text-[13px] font-medium mb-1">
                                        Description
                                    </label>
                                    <textarea
                                        name="description"
                                        value={formData.description}
                                        onChange={handleChange}
                                        className="w-full border p-2 rounded text-[10px] sm:text-[12px]"
                                        rows="3"
                                    />
                                </div>
                            </div>
                            <div className="flex justify-end gap-3 mt-3 sm:mt-6 p-2 sm:p-6">
                                <Button
                                    variant="danger"
                                    onClick={() => {
                                        setShowModal(false);
                                        setEditingProjectIndex(null);
                                        setFormData({
                                            title: "",
                                            leadSource: [],
                                            company: "",
                                            website: "",
                                            description: "",
                                            budget: "",
                                            rate: "Fixed",
                                            hourlyRate: "",
                                            chargedHours: "",
                                            upfrontAmount: "",
                                            pendingAmount: "",
                                            totalCharged: "",
                                        });
                                    }}

                                >
                                    Cancel
                                </Button>

                                <Button
                                    variant="success"
                                    onClick={handleSubmit}
                                    disabled={leadsloading}
                                    className="flex items-center justify-center gap-2 min-w-[110px]"
                                >
                                    {leadsloading ? (
                                        <>
                                            Saving...
                                            <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                                        </>
                                    ) : (
                                        "Save"
                                    )}
                                </Button>
                            </div>
                            <div className="px-6 max-w-3xl mb-10">
                                <Button
                                    className="mb-6"
                                    onClick={() => setShowProjectForm(!showProjectForm)}
                                >
                                    {showProjectForm ? "Close Project Form" : "Add Project"}
                                </Button>

                                {showProjectForm && (
                                    <div className="grid grid-cols-2 gap-4">

                                        {/* Project Name */}
                                        <div className="flex flex-col">
                                            <label className="text-sm font-medium mb-1">
                                                Project Name
                                            </label>
                                            <Input
                                                name="projectName"
                                                value={projectData.projectName}
                                                onChange={handleChangeProjects}
                                                type="text"
                                                placeholder="Enter project name"
                                            />
                                        </div>

                                        {/* Project Title */}
                                        <div className="flex flex-col">
                                            <label className="text-sm font-medium mb-1">
                                                Project Title
                                            </label>
                                            <Input
                                                name="projectTitle"
                                                value={projectData.projectTitle}
                                                onChange={handleChangeProjects}
                                                type="text"
                                                placeholder="Enter project title"
                                            />
                                        </div>

                                        {/* Store Link */}
                                        <div className="flex flex-col">
                                            <label className="text-sm font-medium mb-1">
                                                Store Link
                                            </label>
                                            <Input
                                                name="storeLink"
                                                value={projectData.storeLink}
                                                onChange={handleChangeProjects}
                                                type="text"
                                                placeholder="https://store.com"
                                            />
                                        </div>

                                        {/* Figma Link */}
                                        <div className="flex flex-col">
                                            <label className="text-sm font-medium mb-1">
                                                Figma Link
                                            </label>
                                            <Input
                                                name="figmaLink"
                                                value={projectData.figmaLink}
                                                onChange={handleChangeProjects}
                                                type="text"
                                                placeholder="https://figma.com/..."
                                            />
                                        </div>

                                        {/* Description Full Width */}
                                        <div className="flex flex-col col-span-2">
                                            <label className="text-sm font-medium mb-1">
                                                Task Description
                                            </label>
                                            <textarea
                                                name="description"
                                                value={projectData.description}
                                                onChange={handleChangeProjects}
                                                rows="3"
                                                className="w-full border p-2 rounded text-[10px] sm:text-[12px]"
                                                placeholder="Enter task description"
                                            />
                                        </div>

                                        {/* Button Row */}
                                        <div className="col-span-2 flex justify-end">
                                            <Button
                                                onClick={handleSaveProject}
                                                disabled={loading}
                                                className="flex items-center gap-2"
                                            >
                                                {loading && (
                                                    <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                                                )}
                                                {loading ? "Saving..." : "Save Projects"}
                                            </Button>
                                        </div>

                                        {/* Message */}
                                        {message && (
                                            <div
                                                className={`col-span-2 text-sm text-right font-medium ${messageType === "error" ? "text-red-600" : "text-green-600"
                                                    }`}
                                            >
                                                {message}
                                            </div>
                                        )}

                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                )
            }

            {
                previewLeads && (
                    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-2 sm:px-4" onClick={() => setPreviewLeads(null)}>
                        <div
                            className="bg-white relative rounded-lg w-full max-w-[700px] shadow-lg h-[80vh] overflow-hidden animate-scaleIn"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div className="sticky top-0 z-10 flex justify-between items-center bg-gray-900 px-2 py-2 xl:px-3 xl:py-3">
                                <h2 className="text-white font-semibold text-[14px] sm:text-[18px]">
                                    Leads Detail
                                </h2>

                                <button
                                    className="text-white hover:text-red-400"
                                    onClick={() => setPreviewLeads(null)}
                                >
                                    <X size={20} />
                                </button>
                            </div>
                            <div className="p-6 overflow-y-auto h-full pb-[60px]">
                                <h2 className="text-[16px] sm:text-[20px] font-semibold mb-3">Project Information</h2>
                                <table className="w-full border border-gray-200 rounded-md mb-6">
                                    <tbody className="divide-y">
                                        <InfoRow label="Project Title" value={previewLeads.title || "-"} />
                                        <InfoRow label="Lead Source" value={previewLeads.leadSource || "-"} />
                                        <InfoRow label="Company" value={previewLeads.company || "-"} />
                                        <InfoRow label="Website" value={previewLeads.website || "-"} />
                                        <tr className="text-[10px] sm:text-[12px]">
                                            <td className="px-4 py-2 font-medium text-gray-600 flex w-full">
                                                Job Description
                                            </td>

                                            <td className="px-4 py-2 text-gray-800 whitespace-pre-wrap break-words">
                                                <span>
                                                    {showFullDesc
                                                        ? previewLeads.description
                                                        : truncateText(previewLeads.description, 200)}
                                                </span>

                                                {previewLeads.description?.length > 100 && (
                                                    <button
                                                        onClick={() => setShowFullDesc(!showFullDesc)}
                                                        className="ml-2 text-blue-600 text-xs hover:underline"
                                                    >
                                                        {showFullDesc ? "Show less" : "Read more"}
                                                    </button>
                                                )}
                                            </td>
                                        </tr>
                                        <InfoRow label="Spent Connects" value={previewLeads.spentConnects || "-"} />
                                        <InfoRow label="Lead Id" value={previewLeads.leadId || "-"} />
                                        <InfoRow label="Job Link" value={previewLeads.jobLink || "-"} />
                                        <InfoRow label="Budget" value={`$${previewLeads.budget || "-"}`} />
                                        <InfoRow label="Rate" value={previewLeads.rate || "-"} />
                                        <InfoRow label="hourly Rate" value={`$${previewLeads.hourlyRate || "-"}`} />
                                        <InfoRow label="Charged Hours" value={`${previewLeads.chargedHours || "-"}`} />
                                        <InfoRow label="Upfront Amount" value={`$${previewLeads.upfrontAmount || "-"}`} />
                                        <InfoRow label="Pending Amount" value={`$${previewLeads.pendingAmount || "-"}`} />
                                        <InfoRow label="Total Charged" value={`$${previewLeads.totalCharged || "-"}`} />
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>)
            }
        </div >
    );
}